import React from 'react';

import styled from 'styled-components';

import Radio from 'components/lib/Radio';

import CompaniesCreateEditModalContentMysteryShoppingShopsPerYear from './CompaniesCreateEditModalContentMysteryShoppingShopsPerYear';
import CompaniesCreateEditModalContentMysteryShoppingShopTime from './CompaniesCreateEditModalContentMysteryShoppingShopTime';
import { useCompaniesCreateEditModalContext } from './CompaniesCreateEditModalContext';
import { COMPANY_KEYS, SHOPS_PER_YEAR } from './constants';

const TextContainer = styled.div`
  margin-top; 10px;
  margin-bottom: 15px;
`;

const Label = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const Text = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-flow: column;
`;

const StyledRadioButton = styled(Radio)`
  font-family: var(--font-regular);
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const CompaniesCreateEditModalContentMysteryShoppingShopSchedule = () => {
  const { company, handleChange } = useCompaniesCreateEditModalContext();
  const { shops_per_year = SHOPS_PER_YEAR.QUARTERLY } = company?.mystery_shop_setting ?? {};

  const showQuarterly = shops_per_year == SHOPS_PER_YEAR.QUARTERLY;

  const handleShopsPerMonthChange = (event: any) => {
    const value = event.target.value;
    const mystery_shop_setting = { ...company?.mystery_shop_setting };
    mystery_shop_setting.shops_per_year = value;
    if (value !== SHOPS_PER_YEAR.QUARTERLY) {
      mystery_shop_setting.shop_months = mystery_shop_setting.shop_months ?? [].slice(0, 2);
    }
    handleChange(COMPANY_KEYS.MYSTERY_SHOP_SETTING, mystery_shop_setting);
  };

  return (
    <div>
      <TextContainer>
        <Label>Shop Schedule</Label>
        <Text>By default, mystery shopping will run according to the schedule defined below. </Text>
      </TextContainer>
      <StyledRadioGroup value={shops_per_year} onChange={handleShopsPerMonthChange}>
        <StyledRadioButton value={SHOPS_PER_YEAR.QUARTERLY}>Quarterly (4 shops per year)</StyledRadioButton>
        {showQuarterly && <CompaniesCreateEditModalContentMysteryShoppingShopsPerYear />}
        <StyledRadioButton value={SHOPS_PER_YEAR.SEMI_ANNUALLY}>Semiannually (2 shops per year)</StyledRadioButton>
        {!showQuarterly && <CompaniesCreateEditModalContentMysteryShoppingShopsPerYear />}
      </StyledRadioGroup>
      <CompaniesCreateEditModalContentMysteryShoppingShopTime />
    </div>
  );
};

export default CompaniesCreateEditModalContentMysteryShoppingShopSchedule;
